import Layout from "../components/Layout"
import React, { useRef, useState } from "react"
import Title from "../components/Title"
import Button from "../components/Button"
import { useQueryParam, StringParam } from "use-query-params"
import { Link } from "gatsby"
import firebase from "firebase/compat/app"
import "firebase/compat/firestore"
const firebaseConfig = {
  apiKey: "AIzaSyAlcJNtz76YxD8RieohVopwc91xkNefJ9Y",
  authDomain: "keepit-lanka.firebaseapp.com",
  projectId: "keepit-lanka",
  storageBucket: "keepit-lanka.appspot.com",
  messagingSenderId: "477826760254",
  appId: "1:477826760254:web:ceeff3ca7582f8c844db6f",
  measurementId: "G-5L9KD2SS77"
};
firebase.initializeApp(firebaseConfig)

const db = firebase.firestore()

const Rec = () => {
  return (
    <div className="italic">
      We highly recommend you to see our{" "}
      <Link to="/pricing" className="underline">
        plans
      </Link>{" "}
      before continue. If you already from there please continue.
    </div>
  )
}
const Form = ({plan}) => {
  const [loading,setLoading] = useState(false)
  const handleSendQuery =(e)=>{
    setLoading(true)
    e.preventDefault()
    db.collection('inqueries').add({
      name:name.current.value,
      email:email.current.value,
      plan:plan ? plan : c_plan.current.value,
      at:new Date()
    }).then(()=>{
      alert(`Thank you ${name.current.value.split(' ')[0]}. We will contact you soon.` )
      name.current.value=email.current.value=''
      setLoading(false)

    }).catch(err=>{
      alert(`Something happend while sending the inquery. Please try again later.` )
      setLoading(false)
    })
  }
  const name= useRef()
  const email= useRef()
  const c_plan= useRef()
  return (
    <div className="flex flex-col mt-12 items-center">
      <Title>Let's Get Started</Title>
      <div className="text-base sm:text-lg text-center mb-16">
        Please fill this amazing form and send us to make a great start.
        {!plan && <Rec/>}
      </div>
      <form onSubmit={handleSendQuery} className="flex flex-col gap-8 items-center w-full">
        <input
          type="text"
          placeholder="Your Name"
          required
          ref={name}
          className="py-5 px-8 bg-blue placeholder-black bg-opacity-10 focus:bg-opacity-20 rounded-full w-full max-w-sm"
        />
        <input
          type="email"
          placeholder="Your Email"
          required
          ref={email}
          className="py-5 px-8 bg-blue placeholder-black focus:bg-opacity-20 bg-opacity-10 rounded-full w-full max-w-sm"
        />
        <select
          required
          ref={c_plan}
          defaultValue={plan}
          className="py-5 px-8 bg-blue bg-opacity-10 font-bold rounded-full w-full max-w-sm text-black focus:bg-opacity-20"
        >
          <option value=""  >Select Your Plan</option>
          <option value="starter" >Starter</option>
          <option value="intermediate" >Intermediate</option>
          <option value="ultimate" >Ultimate</option>
        </select>
        <div className="w-max">
          <Button disabled={loading}>{loading ? 'Sending...' : 'Send Inquery'}</Button>
        </div>
      </form>
    </div>
  )
}
export default function GetStarted({ location }) {
  const [plan] = useQueryParam("plan", StringParam)
  return (
    <Layout location={location.pathname}>
      <div className="flex flex-col w-full gap-48 h-full max-w-5xl w-full mx-auto text-base  sm:text-lg  px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 ">
        <Form plan={plan}/>
      </div>
    </Layout>
  )
}
